import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const tagListDefaultVariants = {}
const tagListCompoundVariants = []

const tagListSlotNames = [
  [
    "list",
    "tag-list__list"
  ],
  [
    "loadingWrap",
    "tag-list__loadingWrap"
  ],
  [
    "number",
    "tag-list__number"
  ]
]
const tagListSlotFns = /* @__PURE__ */ tagListSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, tagListDefaultVariants, getSlotCompoundVariant(tagListCompoundVariants, slotName))])

const tagListFn = memo((props = {}) => {
  return Object.fromEntries(tagListSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const tagListVariantKeys = [
  "isLoading"
]
const getVariantProps = (variants) => ({ ...tagListDefaultVariants, ...compact(variants) })

export const tagList = /* @__PURE__ */ Object.assign(tagListFn, {
  __recipe__: false,
  __name__: 'tagList',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: tagListVariantKeys,
  variantMap: {
  "isLoading": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, tagListVariantKeys)
  },
  getVariantProps
})